/**
 * 検査対象が存在するかどうかをチェックします。
 * 存在するかとは、undefinedでもnullでもないことを指します。
 *
 * @template T - 検査対象の型。
 * @param value - 検査対象。
 * @returns 存在する場合は true 、しない場合は false。
 */
export function exists<T>(value: T | null | undefined): value is T {
  return value !== undefined && value !== null
}
